import { useState, useEffect } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

const useVisitorCounter = () => {
  const location = useLocation();
  const [stats, setStats] = useState({
    totalPageViews: 0,
    pageStats: [],
    weeklyData: [],
    loading: true,
    error: null,
  });

  // Function to track page views
  const trackPageView = async (pagePath) => {
    /* console.log(`Melacak kunjungan ke halaman: ${pagePath}`); */
    try {
      await axios.get(`${API_URL}/api/visitors/stats?page=${pagePath}`);
      /* console.log(`Berhasil melacak ${pagePath}`); */
    } catch (error) {
      /* console.error("Error melacak kunjungan:", error); */
    }
  };

  // Function to fetch visitor stats
  // Function to fetch visitor stats
  const fetchVisitorStats = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/visitors/stats`);

      // backend udah kirim data langsung, tanpa success/data wrapper
      setStats({
        totalPageViews: response.data.totalPageViews,
        pageStats: response.data.pageStats,
        weeklyData: response.data.weeklyData,
        loading: false,
        error: null,
      });
    } catch (error) {
      console.error("Error fetching visitor stats:", error);
      setStats((prev) => ({ ...prev, loading: false, error: error.message }));
    }
  };

  // Track page views only for non-admin pages
  useEffect(() => {
    const pagePath = location.pathname;
    if (
      !pagePath.startsWith("/admin/") &&
      !pagePath.startsWith("/monitoring/")
    ) {
      trackPageView(pagePath);
    }
  }, [location]);

  // Fetch stats initially and every 5 minutes
  useEffect(() => {
    fetchVisitorStats();
    const interval = setInterval(fetchVisitorStats, 300000); // 5 minutes
    return () => clearInterval(interval);
  }, []);

  return {
    stats,
    fetchVisitorStats,
    loading: stats.loading,
    error: stats.error,
  };
};

export default useVisitorCounter;
